import { render, staticRenderFns } from "./OutboundModal.vue?vue&type=template&id=24e949bd"
import script from "./OutboundModal.vue?vue&type=script&lang=js"
export * from "./OutboundModal.vue?vue&type=script&lang=js"
import style0 from "./OutboundModal.vue?vue&type=style&index=0&id=24e949bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports